var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9283 12.0001C22.1906 10.7224 21.114 9.67355 19.8174 8.96956C18.5208 8.26557 17.0548 7.93384 15.5814 8.01106C14.1081 8.08827 12.6848 8.57142 11.4689 9.40709C10.253 10.2428 9.29186 11.3984 8.69177 12.7462M24.7683 9.51546L24.0389 12.675C23.9147 13.2131 23.3777 13.5487 22.8396 13.4244L19.68 12.695M9.07189 20C9.80958 21.2777 10.8862 22.3265 12.1828 23.0305C13.4794 23.7345 14.9454 24.0662 16.4188 23.989C17.8921 23.9118 19.3154 23.4287 20.5313 22.593C21.7472 21.7573 22.7084 20.6017 23.3085 19.2539M7.23191 22.4846L7.96133 19.3251C8.08556 18.787 8.62251 18.4514 9.16064 18.5757L12.3202 19.3051",
    stroke: "#BABDCC",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.5ca1e8d0ec65c058e0c068d835491c36.svg";
export { ForwardRef as ReactComponent };